import React, { memo } from 'react';

import styles from './AiAnswerIndex.module.less';
import aiLoading from '../../../../static/aigc/ai_loading.gif';

export default memo(() => {
  return (
    <div className={styles.loading}>
      {/* <img src={aiLoading} /> */}
      <div className={styles.loading_img} />
    </div>
  );
});
